import React from 'react'
import ReactDOM from 'react-dom'
import './styles/App.scss'
import { Provider } from 'react-redux'
import AppContainer from './containers/AppContainer'
import store from './store'

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <AppContainer />
    </React.StrictMode>
  </Provider>,
  document.getElementById('root'),
)
